//
import React, { useState, useRef, useEffect } from 'react';
import '../../VendorStyles/Menu.css';
import DeleteItem from './DeleteItem';
import '../../VendorStyles/EditPopup.css';
import UpdateItem from './UpdateItem';
import AddMenuType from './AddMenuType';
import { toast } from 'react-toastify';
import axiosVendorInstance from '../../axiosVendorInstance';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import greenDot from '../../assets/greendot.svg';
import redDot from '../../assets/reddot.svg';
import VendorSideMenuBar from './VendorLayouts/VendorSideMenuBar';
import VendorTopMenuBar from './VendorLayouts/VendorTopMenuBar';
import DeleteMenu from './DeleteMenu';
import Loader from '../../Components/Loader/Loader';
import EditPencilIconSvg from '../../assets/svg/editPencilIcon';
import DeleteIconSvg from '../../assets/svg/deleteIcon';
import PlusIconSvg from '../../assets/svg/plusIcon';
import VendorImageMenuPlaceholderSvg from '../../assets/svg/vendorImageMenuPlaceholder';
import { useNavigate, useLocation } from 'react-router-dom';
import LeftArrow from '../../assets/backIcon-white.png';
import FoodMenuDetailsModal from '../User/Search/FoodMenuDetailsModal';
import { IoPlayOutline } from 'react-icons/io5';
import axios from 'axios';
import image1 from '../../assets/Image1.png';

function Menu() {
    const navigate = useNavigate();
    const location = useLocation();
    const isUpdateMode = location.pathname.includes('/menu/updateItem');
    const [vendorID, setVendorID] = useState(null);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [newMenuType, setNewMenuType] = useState('');
    const [isEditingMenu, setIsEditingMenu] = useState(false);
    const params = new URLSearchParams(window.location.search);
    const addItemParam = params.get('addItem');
    const initialIsAddingItem = addItemParam === 'true' || (window.history.state && window.history.state.usr && window.history.state.usr.openAddItemForm) ? true : false;
    const [isAddingItem, setIsAddingItem] = useState(initialIsAddingItem);
    const [uploadedFile, setUploadedFile] = useState('');
    const [previewFile, setPreviewFile] = useState(null);
    const [itemName, setItemName] = useState('');
    const [externalItemId, setExternalItemId] = useState('');
    const [itemDescription, setItemDescription] = useState('');
    const [itemPrice, setItemPrice] = useState('');
    const [itemIngredients, setItemIngredients] = useState('');
    const [menuType, setMenuType] = useState();
    const [selectedMenuType, setSelectedMenuType] = useState('');
    const [addMenuPopupOpen, setAddMenuPopupOpen] = useState(false);
    const [deleteMenuPopupOpen, setDeleteMenuPopupOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedOption, setSelectedOption] = useState('');
    const [itemVegetarian, setItemVegetarian] = useState('');
    const [menuTypes, setMenuTypes] = useState([]);
    const [Items, setItems] = useState([]);
    const [fileType, setFileType] = useState(null);
    const [updatedImage, setUpdatedImage] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [selectedFood, setSelectedFood] = useState(null);
    const [openFoodDetail, setOpenFoodDetail] = useState(false);
    const [itemNameError, setItemNameError] = useState('');
    const [itemPriceError, setItemPriceError] = useState('');
    const [menuTypeError, setMenuTypeError] = useState();
    const [itemVegetarianError, setItemVegetarianError] = useState();
    const [itemDescriptionError, setItemDescriptionError] = useState('');
    const [itemIngredientsError, setItemIngredientsError] = useState('');
    const [imageError, setImageError] = useState('');
    const [smallTrayPriceError, setSmallTrayPriceError] = useState('');
    const [mediumTrayPriceError, setMediumTrayPriceError] = useState('');
    const [largeTrayPriceError, setLargeTrayPriceError] = useState('');
    const [partyTrayError, setPartyTrayError] = useState('');
    // Global vendor-level toggles (outside Add Item)
    const [allowPickup, setAllowPickup] = useState(true);
    const [allowDelivery, setAllowDelivery] = useState(true);
    const [allowScheduled, setAllowScheduled] = useState(true);
    const [savingAvailability, setSavingAvailability] = useState(false);
    const [menuId, setMenuId] = useState(null);
    const [menuIdToDelete, setMenuIdToDelete] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
    const videoRefs = useRef({});
    const [playingIndex, setPlayingIndex] = useState(null);
    const [loading, setLoading] = useState(false);
    // Removed vendor-level Party/Daily/Schedule toggles per request
    const [isPartyTray, setIsPartyTray] = useState(false);
    const [smallTrayPrice, setSmallTrayPrice] = useState('');
    const [mediumTrayPrice, setMediumTrayPrice] = useState('');
    const [largeTrayPrice, setLargeTrayPrice] = useState('');
    // Item-level order availability
    const [supportsDaily, setSupportsDaily] = useState(true);
    const [supportsParty, setSupportsParty] = useState(false);
    // Removed item-level Schedule/Pickup/Delivery (handled globally)

    // Link party toggle to party tray metadata and reset prices when off
    useEffect(() => {
        setIsPartyTray(!!supportsParty);
        if (!supportsParty) {
            setSmallTrayPrice('');
            setMediumTrayPrice('');
            setLargeTrayPrice('');
        }
    }, [supportsParty]);

    // No vendor-level seeding for item-level toggles

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const addItemParam = params.get('addItem');
        if (addItemParam === 'true' || (location.state && location.state.openAddItemForm)) {
            handleAddItemClick();
        }
        if (location.state && location.state.itemData) {
            const item = location.state.itemData;
            handleAddItemClick();
            setItemName(item.name || '');
            setItemPrice(item.price_cents ? (item.price_cents / 100).toFixed(2) : '');
            setItemDescription(item.description || '');
            setItemIngredients(''); // No ingredients info from CloverConnect
            setExternalItemId(item.id || '');
            setItemVegetarian(''); // No veg info from CloverConnect
            setUploadedFile(''); // No file from CloverConnect
            setPreviewFile(null);
        }
    }, []);

    useEffect(() => {
        if (location.state && location.state.itemData && menuTypes.length > 0) {
            const item = location.state.itemData;
            let matchedMenuTypeId = '';
            if (item.categories && item.categories.length > 0) {
                const categoryNames = item.categories.map(cat => cat.name.toLowerCase());
                console.log('Category Names:', categoryNames);
                console.log('Menu Types:', menuTypes.map(mt => mt.Menu_name));
                const matchedMenuType = menuTypes.find(menuType =>
                    categoryNames.some(catName => menuType.Menu_name.toLowerCase().includes(catName) || catName.includes(menuType.Menu_name.toLowerCase()))
                );
                console.log('Matched Menu Type:', matchedMenuType);
                if (matchedMenuType) {
                    matchedMenuTypeId = matchedMenuType.ID;
                }
            }
            setSelectedMenuType(matchedMenuTypeId);
        }
    }, [location.state, menuTypes]);
    // Hydrate global toggles from localStorage
    useEffect(() => {
        if (!vendorID) return;
        try {
            const ap = localStorage.getItem(`allowPickup:${vendorID}`);
            const ad = localStorage.getItem(`allowDelivery:${vendorID}`);
            const as = localStorage.getItem(`allowScheduled:${vendorID}`);
            setAllowPickup(ap === null ? true : ap === 'true');
            setAllowDelivery(ad === null ? true : ad === 'true');
            setAllowScheduled(as === null ? true : as === 'true');
        } catch (e) {
            // ignore
        }
    }, [vendorID]);

    const updateVendorAvailability = async (nextPickup, nextDelivery, nextScheduled) => {
        if (!vendorID) return;
        setSavingAvailability(true);
        try {
            await axiosVendorInstance.put(
                '/vendors/vendoravaialabiltiy/account',
                {
                    // API expects lowercase keys
                    schedule: !!nextScheduled,
                    pickup: !!nextPickup,
                    delivery: !!nextDelivery,
                }
            );
            try {
                localStorage.setItem(`allowPickup:${vendorID}`, String(nextPickup));
                localStorage.setItem(`allowDelivery:${vendorID}`, String(nextDelivery));
                localStorage.setItem(`allowScheduled:${vendorID}`, String(nextScheduled));
            } catch (e) { /* ignore localStorage errors */ }
            toast.success('Availability updated');
        } catch (error) {
            toast.error('Error updating availability');
            // Best effort: refetch from localStorage to revert
            try {
                const ap = localStorage.getItem(`allowPickup:${vendorID}`);
                const ad = localStorage.getItem(`allowDelivery:${vendorID}`);
                const as = localStorage.getItem(`allowScheduled:${vendorID}`);
                setAllowPickup(ap === null ? true : ap === 'true');
                setAllowDelivery(ad === null ? true : ad === 'true');
                setAllowScheduled(as === null ? true : as === 'true');
            } catch (e) { /* ignore */ }
        } finally {
            setSavingAvailability(false);
        }
    };

    const handlePlay = (e, index) => {
        e.stopPropagation();

        Object.entries(videoRefs.current).forEach(([key, video]) => {
            if (parseInt(key) !== index && video && !video.paused) {
                video.pause();
            }
        });

        const currentVideo = videoRefs.current[index];
        if (currentVideo) {
            currentVideo.play();
            setPlayingIndex(index);
        }
    };

    const openDeletePopUp = (id) => {
        setShowDeletePopup(true);
        setDeleteItemId(id);
    };
    const closeDeletePopUp = () => {
        setShowDeletePopup(false);
    };
    const handleClose = () => {
        setOpenFoodDetail(false);
        setSelectedFood(null);
    };

    const fetchFoodDetails = async (itemId, autoplay = false) => {
        try {
            const response = await axiosVendorInstance.get(
                `/vendors/menuitems/particularitem/${itemId}`
            );
            const food = response?.data?.menuItem;

            if (food) {
                setSelectedFood({
                    ...food,
                    autoplay: autoplay
                });
                setOpenFoodDetail(true);
            }
        } catch (error) {
            console.error('Error fetching offer details:', error);
        }
    };


    const validate = () => {
        let isValid = true;
        // Allow almost all printable characters (including emojis),
        // while disallowing angle brackets. Minimum length: 4 chars.
        const nameRegex = /^[^<>]{4,}$/;
        const priceRegex = /^(100(\.00?)?|(\d{1,2}(\.\d{1,2})?))$/;

        if (!itemName.trim()) {
            setItemNameError('Food name is required.');
            isValid = false;
        } else if (!nameRegex.test(itemName)) {
            setItemNameError('Enter valid food name.');
            isValid = false;
        } else {
            setItemNameError('');
        }

        // Price Validation
        if (!itemPrice.trim()) {
            setItemPriceError('Field is required.');
            isValid = false;
        } else if (!priceRegex.test(itemPrice)) {
            setItemPriceError('Enter a valid price (e.g., 20 or 20.50).');
            isValid = false;
        } else {
            setItemPriceError('');
        }

        // Description Validation
        const descriptionText = itemDescription.replace(/<(.|\n)*?>/g, '').trim();
        if (!descriptionText) {
            setItemDescriptionError('Description is required.');
            isValid = false;
        } else if (/(\s{3,})/.test(descriptionText)) {
            setItemDescriptionError(
                'Description cannot have more than 2 consecutive spaces.'
            );
            isValid = false;
        } else if (/([a-zA-Z0-9]{20,})/.test(descriptionText)) {
            setItemDescriptionError(
                'Description cannot contain long continuous text without spaces.'
            );
            isValid = false;
        } else {
            setItemDescriptionError('');
        }

        // Ingredients Validation
        const ingredientsText = itemIngredients.replace(/<(.|\n)*?>/g, '').trim();
        if (!ingredientsText) {
            setItemIngredientsError('Ingredients is required.');
            isValid = false;
        } else if (/(\s{3,})/.test(ingredientsText)) {
            setItemIngredientsError(
                'Ingredients cannot have more than 2 consecutive spaces.'
            );
            isValid = false;
        } else if (/([a-zA-Z0-9]{20,})/.test(ingredientsText)) {
            setItemIngredientsError(
                'Ingredients cannot contain long continuous text without spaces.'
            );
            isValid = false;
        } else {
            setItemIngredientsError('');
        }

        if (!selectedMenuType) {
            setMenuTypeError('Please select a menuType.');
            isValid = false;
        } else {
            setMenuTypeError('');
        }

        if (!itemVegetarian) {
            setItemVegetarianError('Please select a foodType.');
            isValid = false;
        } else {
            setItemVegetarianError('');
        }

        if (!uploadedFile) {
            setImageError('Image/Video is required.');
            isValid = false;
        }

        // Party tray validations (minimal)
        if (supportsParty) {
            const priceRgx = /^(\d+)(?:\.(\d{1,2}))?$/;

            const s = smallTrayPrice.trim();
            const m = mediumTrayPrice.trim();
            const l = largeTrayPrice.trim();
            const anyProvided = Boolean(s || m || l);

            setSmallTrayPriceError('');
            setMediumTrayPriceError('');
            setLargeTrayPriceError('');
            setPartyTrayError('');

            if (!anyProvided) {
                setPartyTrayError('Enter at least one tray price or turn off Party.');
                isValid = false;
            }

            if (s && !priceRgx.test(s)) {
                setSmallTrayPriceError('Enter a valid amount (e.g., 49.99).');
                isValid = false;
            }
            if (m && !priceRgx.test(m)) {
                setMediumTrayPriceError('Enter a valid amount (e.g., 79.99).');
                isValid = false;
            }
            if (l && !priceRgx.test(l)) {
                setLargeTrayPriceError('Enter a valid amount (e.g., 109.99).');
                isValid = false;
            }
        } else {
            setSmallTrayPriceError('');
            setMediumTrayPriceError('');
            setLargeTrayPriceError('');
            setPartyTrayError('');
        }

        return isValid;
    };

    const fetchVendorID = async () => {
        try {
            const response = await axiosVendorInstance.get('/vendors/account');
            const apiResponse = response?.data?.getVendorInfo;
            console.log('apiResponse',apiResponse);
            setVendorID(apiResponse[0]?.ID);
        } catch (error) {
            console.error('Error fetching vendor id:', error);
        }
    };

    useEffect(() => {
        fetchVendorID();
        fetchMenuTypes();
        fetchMenuItems();
    }, [vendorID]);

    // Removed vendor-level toggles state hydration

    // Removed vendor-level party toggle

    // Persist tray mapping automatically when it changes
    // Removed vendor-level tray mapping persistence

    // Removed Party Orders toggle and mapping

    // Removed vendor-level ASAP toggle

    // No vendor-level tray mapping persistence

    // Removed vendor-level Scheduled toggle

    const fetchMenuTypes = async () => {
        if (vendorID !== null) {
            try {
                setLoading(true);
                const response = await axiosVendorInstance.get(`/vendors/${vendorID}`, {
                    skipAuth: true,
                });
                setLoading(false);
                const apiResponse = response?.data;

                setMenuTypes(apiResponse);
            } catch (error) {
                setLoading(false);
                console.error('Error fetching menu types:', error);
            }
        }
    };

    const fetchMenuItems = async () => {
        if (vendorID !== null) {
            try {
                const response = await axiosVendorInstance.get(
                    `/vendors/menuitems/vendorpage/${vendorID}`,
                    { skipAuth: true }
                );
                const { menuItems } = response.data;

                const groupedItems = {};
                menuItems.forEach((item) => {
                    const menuId = item.Menu_id;
                    if (!groupedItems[menuId]) {
                        groupedItems[menuId] = [];
                    }
                    groupedItems[menuId].push(item);
                });

                setItems(groupedItems);
            } catch (error) {
                console.error('Error fetching menu items:', error);
            }
        }
    };

    const fetchAvailableStatus = async (itemId, vendorId) => {
        if (!vendorId || !itemId) return true; // Default to active if no vendorId or itemId
        
        try {
            const response = await axios.get(`https://pro-customers-api.omyfood.io/api/cartdetails/clover/itemscategories/${vendorId}`);
            const items = response.data?.syncedItems || [];
            
            const cloverItem = items.find(item => item.id === itemId);
            if (cloverItem) {
                return cloverItem.available; // Return the availability status
            }
            return true; // Default to active if no Clover item found
        } catch (error) {
            console.error('Error fetching available status from Clover:', error);
            return true; // Default to active on error
        }
    };

    const ToggleButton = ({ status, itemId, vendorID, onToggle }) => {
        const [isOn, setIsOn] = useState(status === 'active');
        const [isLoading, setIsLoading] = useState(false);

        useEffect(() => {
            setIsOn(status === 'active');
        }, [status]);

        const fetchAvailableStatus = async () => {
            if (!vendorID || !itemId) return;
            
            try {
                setIsLoading(true);
                const response = await axios.get(`https://pro-customers-api.omyfood.io/api/cartdetails/clover/itemscategories/${vendorID}`);
                const items = response.data?.syncedItems || [];
                
                const cloverItem = items.find(item => item.id === itemId);
                if (cloverItem) {
                    setIsOn(cloverItem.available);
                }
            } catch (error) {
                console.error('Error fetching available status from Clover:', error);
            } finally {
                setIsLoading(false);
            }
        };

        // Call fetchAvailableStatus on component mount to sync with Clover
        useEffect(() => {
            fetchAvailableStatus();
        }, [itemId, vendorID]);

        const handleToggleClick = () => {
            if (onToggle) {
                onToggle(!isOn);
            }
        };

        return (
            <div
                className={`menu-toggle-switch ${isOn ? 'on' : 'off'} ${isLoading ? 'loading' : ''}`}
                onClick={handleToggleClick}
                style={{ opacity: isLoading ? 0.6 : 1 }}
            >
                <div className="menu-toggle-switch-inner">
                    <div
                        className="menu-toggle-switch-circle"
                        style={{ right: isOn ? 3 : 'auto', left: isOn ? 'auto' : 3 }}
                    ></div>
                </div>
                <span className={`menu-toggle-state-text ${isOn ? 'on' : 'off'}`}>
                    {isLoading ? '...' : (isOn ? 'on' : 'off')}
                </span>
            </div>
        );
    };

    const handleToggleChange = async (id, newStatus) => {
        try {
            // Find the item to get its external_item_id
            let externalItemId = null;
            Object.keys(Items).forEach((menuId) => {
                const item = Items[menuId].find(item => item.ID === id);
                if (item && item.external_item_id) {
                    externalItemId = item.external_item_id;
                }
            });

            // If this is a Clover item and user is trying to activate it,
            // check if it's available in Clover first
            if (externalItemId && newStatus === true) {
                const cloverAvailable = await fetchAvailableStatus(externalItemId, vendorID);
                if (!cloverAvailable) {
                    toast.error('Cannot activate item. Item is marked as unavailable in Clover. Please update the availability in your Clover system first.');
                    return;
                }
            }

            // Convert boolean to string for API
            const statusString = newStatus ? 'active' : 'deactive';
            
            await axiosVendorInstance.put(
                `/vendors/menuitems/status/${id}`,
                { Status: statusString },
                { skipAuth: true }
            );

            setItems((prevMenuItems) => {
                const updatedMenuItems = { ...prevMenuItems };

                Object.keys(updatedMenuItems).forEach((menuId) => {
                    updatedMenuItems[menuId] = updatedMenuItems[menuId].map((item) => {
                        if (item.ID === id) {
                            return { ...item, Status: statusString };
                        }
                        return item;
                    });
                });

                return updatedMenuItems;
            });

            toast.success(`Status updated to ${statusString}`);
        } catch (error) {
            toast.error(`Error updating status: ${error.message}`);
        }
    };

    const handleNameChange = (e) => {
        const value = e.target.value;
        setItemName(value);

        if (!value.trim()) {
            setItemNameError('Field is required.');
        } else if (!/^[^<>]{4,}$/.test(value)) {
            setItemNameError('Food name must be 4 characters.');
        } else {
            setItemNameError('');
        }
    };

    const handleDescriptionChange = (value) => {
        setItemDescription(value);

        const plainText = value.replace(/<[^>]*>/g, '').trim();

        if (!plainText) {
            setItemDescriptionError('Field is required.');
        } else if (plainText.length < 10) {
            setItemDescriptionError('Description must be at least 10 characters.');
        } else if (/(\s{3})/.test(plainText)) {
            // Check for more than 2 consecutive spaces
            setItemDescriptionError('Description cannot have more than 2 spaces.');
        } else if (/([a-zA-Z0-9]{20,})/.test(plainText)) {
            // Check for long continuous alphanumeric text without spaces
            setItemDescriptionError(
                'Description cannot contain long continuous text without spaces.'
            );
        } else {
            setItemDescriptionError('');
        }
    };

    const handleItemIngredients = (value) => {
        setItemIngredients(value);

        const plainText = value.replace(/<[^>]*>/g, '').trim();

        if (!plainText) {
            setItemIngredientsError('Field is required.');
        } else if (plainText.length < 10) {
            setItemIngredientsError('Ingredients must be at least 10 characters.');
        } else if (/(\s{3})/.test(plainText)) {
            // Check for more than 2 consecutive spaces
            setItemIngredientsError('Ingredients cannot have more than 2 spaces.');
        } else if (/([a-zA-Z0-9]{20,})/.test(plainText)) {
            // Check for long continuous alphanumeric text without spaces
            setItemIngredientsError(
                'Ingredients cannot contain long continuous text without spaces.'
            );
        } else {
            setItemIngredientsError('');
        }
    };

    const handlePriceChange = (e) => {
        const value = e.target.value;
        setItemPrice(value);

        // Check if the value is empty
        if (!value.trim()) {
            setItemPriceError('Field is required.');
            // Check if the value exceeds 100
        } else if (parseFloat(value) > 999) {
            setItemPriceError('Price cannot exceed 999.');
            // Check if the value is a valid price format
        } else if (!/^(100(\.00?)?|(\d{1,3}(\.\d{1,3})?))$/.test(value)) {
            setItemPriceError('Enter a valid price (e.g., 20 or 20.500).');
        } else {
            setItemPriceError('');
        }
    };

    const handleMenuTypeChange = (event) => {
        setSelectedMenuType(event.target.value);
        if (selectedMenuType) {
            setMenuTypeError('');
        }
    };
    const handleVegetarianChange = (event) => {
        setItemVegetarian(event.target.value);
        if (event.target.value) {
            setItemVegetarianError('');
        }
    };
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        setImageError('');
        setPreviewFile(null);

        if (file) {
            const fileExtension = file.name.split('.').pop().toLowerCase();

            const validImageTypes = [
                'jpg',
                'jpeg',
                'png',
                'webp',
                'tiff',
                'gif',
                'bmp',
            ];
            const validVideoTypes = ['mp4'];
            const validHtmlTypes = ['html'];

            if (
                (validImageTypes.includes(fileExtension) && file.type.startsWith('image/')) ||
                (validVideoTypes.includes(fileExtension) && file.type.startsWith('video/')) ||
                (validHtmlTypes.includes(fileExtension) && file.type === 'text/html')
            ) {
                // Removed the file size check
                const fileType = file.type.split('/')[0];
                setFileType(fileType);
                setUploadedFile(file);

                const previewUrl = URL.createObjectURL(file);
                setPreviewFile(previewUrl);
            } else {
                alert('Upload valid images, videos, or HTML files.');
            }
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 601);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleAddItemClick = () => {
        setIsAddingItem(true);
    };

    const handleAddItem = async () => {
        if (validate()) {
            if (isLoading) return;
            setIsLoading(true);

            const itemNameCheckUrl = `/vendors/menuitems/api/menu/${selectedMenuType}/items/check/${encodeURIComponent(itemName)}/vendor/${vendorID}`;

            try {
                const checkResponse = await axiosVendorInstance.get(itemNameCheckUrl, {
                    skipAuth: true,
                });
                if (checkResponse?.data?.exists) {
                    toast.error(
                        'Item name already exists. Please choose a different name.'
                    );
                    return;
                }
                const cleanPrice = parseFloat(itemPrice).toString();

                const formData = new FormData();
                formData.append('Avatar_key', uploadedFile);
                formData.append('Item_name', itemName);
                formData.append('Menu_id', selectedMenuType);
                formData.append('Vendor_ID', vendorID);
                formData.append('Price', cleanPrice);
                formData.append('Description', itemDescription);
                formData.append('Ingridents', itemIngredients);
                formData.append('Vegetarian', itemVegetarian);
                // Party tray metadata (optional)
                formData.append('Party', isPartyTray ? 'true' : 'false');
                if (isPartyTray) {
                    const s = smallTrayPrice ? parseFloat(smallTrayPrice).toString() : '';
                    const m = mediumTrayPrice ? parseFloat(mediumTrayPrice).toString() : '';
                    const l = largeTrayPrice ? parseFloat(largeTrayPrice).toString() : '';
                    formData.append('Small_tray', s);
                    formData.append('Medium_tray', m);
                    formData.append('Large_tray', l);
                }
                const cloverItemAvailable = await fetchAvailableStatus(externalItemId, vendorID);
                formData.append('Status', cloverItemAvailable ? 'active' : 'deactive');
                formData.append('external_item_id', externalItemId);
                // Item-level order availability (only per-item Daily/Party)
                // Send booleans instead of stringified values
                formData.append('Daily', supportsDaily);
                

                try {
                    const postResponse = await axiosVendorInstance.post(
                        `/vendors/menuitems/menu/${selectedMenuType}`,
                        formData,
                        { skipAuth: true }
                    );

                    if (postResponse?.data?.error === 'Item already exists') {
                        toast.error('Item already exists');
                    } else {
                        toast.success('Item Added Successfully');
                        fetchMenuTypes();
                        fetchMenuItems();
                    }
                } catch (error) {
                    toast.error('Error adding item');
                } finally {
                    setIsLoading(false);
                    setIsAddingItem(false);
                    setUploadedFile('');
                    setItemName('');
                    setExternalItemId('');
                    setItemDescription('');
                    setItemIngredients('');
                    setItemPrice('');
                    setMenuType('');
                    setSelectedMenuType('');
                    setItemVegetarian('');
                    setIsPartyTray(false);
                    setSmallTrayPrice('');
                    setMediumTrayPrice('');
                    setLargeTrayPrice('');
                    setSupportsDaily(true);
                    setSupportsParty(false);
                    fetchMenuTypes();
                    fetchMenuItems();
                    setPreviewFile(null);
                }
            } catch (error) {
                toast.error('Error checking item name.');
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handleEditClick = (menu, id) => {
        setNewMenuType(menu);
        setMenuId(id);

        setIsEditingMenu(true);
        setAddMenuPopupOpen(true);
    };

    const resetForm = () => {
        setNewMenuType('');
    };

    const handleDeleteMenuClick = (id) => {
        setMenuIdToDelete(id);
        setDeleteMenuPopupOpen(true);
    };

    const openEditPopup = (item) => {
        setSelectedItem(item);
        setSelectedOption('Update Item');
        navigate(`/menu/updateItem/${item}`);
    };

    const handleBack = () => {
        navigate('/menu');
    };

    const handleAddMenuClick = () => {
        resetForm();
        setAddMenuPopupOpen(true);
        setIsEditingMenu(false);
    };
    const closeAddMenuPopup = () => {
        setAddMenuPopupOpen(false);
    };
    // const handleConnectClover = async (vendorID) => {
    //     try {
    //         const clientId = 'PH1Q3QS6MT2VE';   
    //         const redirectUri = encodeURIComponent('https://customers-api.omyfood.io/api/cartdetails/oauth/callback');
    //         const scope = encodeURIComponent('items:read categories:read modifier_groups:read merchants:read inventory:read orders:write');

    //         // Pass multiple info as state, encoded as JSON string Test
    //         const state = encodeURIComponent(JSON.stringify({ vendorID: vendorID,
    //             returnTo: 'https://omyfood.io/clover-connect'
    //         }));
    //         console.log('state',state);
    //         const url = `https://www.clover.com/oauth/authorize?client_id=${clientId}&scope=${scope}&response_type=code&redirect_uri=${redirectUri}&state=${state}`;
 
    //         window.open(url, '_blank');
    //     } catch (error) {
    //         toast.error('Error connecting It does to Clover display: ' + (error.message || error));
    //     }
    // };


    const closeDeleteMenuPopup = () => {
        setDeleteMenuPopupOpen(false);
    };
    const handleSave = async (updatedItem) => {
        setIsLoading(true);

        const formData = new FormData();
        formData.append('Updated_at', new Date().toISOString());

        if (updatedImage) {
            formData.append('Avatar_key', updatedImage);
        }

        formData.append('Item_name', updatedItem.name);
        formData.append('Menu_id', updatedItem.menuType);
        formData.append('Vendor_ID', vendorID);
        formData.append('Vegetarian', updatedItem.vegetarian);
        formData.append('Price', Number(updatedItem.price));
        formData.append('Description', updatedItem.description);
        formData.append('Ingridents', updatedItem.Ingredients);
        // Item-level availability and party tray metadata for Update
        if (typeof updatedItem.Daily !== 'undefined') {
            formData.append('Daily', updatedItem.Daily);
        }
        if (typeof updatedItem.Party !== 'undefined') {
            formData.append('Party', updatedItem.Party);
        }
        if (updatedItem.Party) {
            const s = updatedItem.Small_tray ? parseFloat(updatedItem.Small_tray).toString() : '';
            const m = updatedItem.Medium_tray ? parseFloat(updatedItem.Medium_tray).toString() : '';
            const l = updatedItem.Large_tray ? parseFloat(updatedItem.Large_tray).toString() : '';
            formData.append('Small_tray', s);
            formData.append('Medium_tray', m);
            formData.append('Large_tray', l);
        }

        try {
            await axiosVendorInstance.put(
                `/vendors/menuitems/${updatedItem.id}`,
                formData
            );

            toast.success('Item Updated Successfully');

            fetchMenuTypes();
            fetchMenuItems();
        } catch (error) {
            toast.error('Error updating menu item');
        } finally {
            setIsLoading(false);
            setIsAddingItem(false);
            setSelectedOption('');
        }

        fetchMenuTypes();
        fetchMenuItems();
    };

    const handleAddMenuType = async (newMenuType, id) => {
        try {
            if (isEditingMenu) {
                const updateMenuUrl = `/vendors/menu/${id}`;
                const updateResponse = await axiosVendorInstance.put(updateMenuUrl, {
                    Menu_name: newMenuType,
                });

                if (updateResponse?.status === 200) {
                    toast.success('Menu updated successfully');
                    fetchMenuTypes();
                }
            } else {
                const checkMenuUrl = `/vendors/${vendorID}/menu/check/${newMenuType.newMenuType}`;

                const checkResponse = await axiosVendorInstance.get(checkMenuUrl, {
                    skipAuth: true,
                });

                if (checkResponse?.data?.exists) {
                    toast.error(
                        'Menu name already exists. Please choose a different name.'
                    );
                    return;
                }

                await axiosVendorInstance.post(
                    `/vendors/${vendorID}`,
                    {
                        Menu_name: newMenuType,
                    },
                    { skipAuth: true }
                );

                toast.success('Menu added successfully');
                fetchMenuTypes();
            }
        } catch (error) {
            toast.error('Failed to add or update menu type');
        }
    };

    const deleteMenuType = async (id) => {
        try {
            const deleteMenuUrl = `/vendors/menu/${id}`;

            const response = await axiosVendorInstance.delete(deleteMenuUrl, {
                skipAuth: true,
            });

            if (response?.status === 200) {
                toast.success('Menu deleted successfully');
                fetchMenuTypes();
            }
        } catch (error) {
            toast.error('Failed to delete menu');
        }
    };

    return (
        <div>
            {loading && <Loader />}
            <VendorSideMenuBar />
            <VendorTopMenuBar />
            <div className="menu-main-container-vendor">
                <div className="vendor-common-container">
                    <div className="vendor-menu-dashboard">
                        <div className="menu-top-1-cont">
                            {/* Global vendor-level toggles: Pickup, Delivery, Schedule (hidden during Add or Update forms) */}
                            {!isAddingItem && !(selectedOption === 'Update Item' && isUpdateMode) && (
                                <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', gap: 18 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <span style={{ fontSize: 14, color: '#2c3142' }}>Pickup</span>
                                        <div
                                            className={`menu-toggle-switch ${allowPickup ? 'on' : 'off'} ${savingAvailability ? 'loading' : ''}`}
                                            onClick={() => {
                                                if (savingAvailability) return;
                                                const next = !allowPickup;
                                                setAllowPickup(next);
                                                updateVendorAvailability(next, allowDelivery, allowScheduled);
                                            }}
                                            style={{ cursor: 'pointer', opacity: savingAvailability ? 0.6 : 1 }}
                                        >
                                            <div className="menu-toggle-switch-inner">
                                                <div className="menu-toggle-switch-circle" style={{ right: allowPickup ? 3 : 'auto', left: allowPickup ? 'auto' : 3 }}></div>
                                            </div>
                                            <span className={`menu-toggle-state-text ${allowPickup ? 'on' : 'off'}`}>{allowPickup ? 'on' : 'off'}</span>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <span style={{ fontSize: 14, color: '#2c3142' }}>Delivery</span>
                                        <div
                                            className={`menu-toggle-switch ${allowDelivery ? 'on' : 'off'} ${savingAvailability ? 'loading' : ''}`}
                                            onClick={() => {
                                                if (savingAvailability) return;
                                                const next = !allowDelivery;
                                                setAllowDelivery(next);
                                                updateVendorAvailability(allowPickup, next, allowScheduled);
                                            }}
                                            style={{ cursor: 'pointer', opacity: savingAvailability ? 0.6 : 1 }}
                                        >
                                            <div className="menu-toggle-switch-inner">
                                                <div className="menu-toggle-switch-circle" style={{ right: allowDelivery ? 3 : 'auto', left: allowDelivery ? 'auto' : 3 }}></div>
                                            </div>
                                            <span className={`menu-toggle-state-text ${allowDelivery ? 'on' : 'off'}`}>{allowDelivery ? 'on' : 'off'}</span>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <span style={{ fontSize: 14, color: '#2c3142' }}>Schedule</span>
                                        <div
                                            className={`menu-toggle-switch ${allowScheduled ? 'on' : 'off'} ${savingAvailability ? 'loading' : ''}`}
                                            onClick={() => {
                                                if (savingAvailability) return;
                                                const next = !allowScheduled;
                                                setAllowScheduled(next);
                                                updateVendorAvailability(allowPickup, allowDelivery, next);
                                            }}
                                            style={{ cursor: 'pointer', opacity: savingAvailability ? 0.6 : 1 }}
                                        >
                                            <div className="menu-toggle-switch-inner">
                                                <div className="menu-toggle-switch-circle" style={{ right: allowScheduled ? 3 : 'auto', left: allowScheduled ? 'auto' : 3 }}></div>
                                            </div>
                                            <span className={`menu-toggle-state-text ${allowScheduled ? 'on' : 'off'}`}>{allowScheduled ? 'on' : 'off'}</span>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <button
                                className="menu-add-item-button"
                                onClick={() => handleAddMenuClick()}
                            >
                                <div className="menu-button-content">
                                    <PlusIconSvg />
                                    <div className="menu-add-item-vertical-line"></div>
                                    <span className="menu-add-item-text">Add Menu</span>
                                </div>
                            </button>
                            <button
                                className="menu-add-item-button"
                                onClick={() => handleAddItemClick()}
                            >
                                <div className="menu-button-content">
                                    <PlusIconSvg />
                                    <div className="menu-add-item-vertical-line"></div>
                                    <span className="menu-add-item-text">Add Item</span>
                                </div>
                            </button>
                        </div>

                        {!isAddingItem ? (
                            selectedOption === 'Update Item' && isUpdateMode ? (
                                <UpdateItem
                                    itemId={selectedItem}
                                    handleFileChange={handleFileChange}
                                    handleSave={handleSave}
                                    menuTypes={menuTypes}
                                    previewFile={previewFile}
                                    setPreviewFile={setPreviewFile}
                                    fileType={fileType}
                                    setFileType={setFileType}
                                    uploadedFile={uploadedFile}
                                    setUploadedFile={setUploadedFile}
                                    setUpdatedImage={setUpdatedImage}
                                    isLoading={isLoading}
                                    menuTypesForEdit={menuType}
                                    handleBack={handleBack}
                                />
                            ) : menuTypes?.length === 0 ? (
                                <p className="no-items-message1">No items in this menu</p>
                            ) : (
                                menuTypes?.map((menu, index) => (
                                    <div key={menu?.ID} className="menu-bottom-container" style={{ paddingBottom: index === menuTypes.length - 1 ? '75px' : '20px' }}>
                                        <div
                                            className="menu-name-and-edit-delete-icons"
                                            style={{
                                                marginTop: index === 0 ? (isMobile ? '55px' : '75px') : '0',
                                            }}
                                        >
                                            <h2 className="menu-name-category">{menu?.Menu_name}</h2>
                                            <div className="menu-edit-and-delete-icons-container">
                                                <EditPencilIconSvg
                                                    width={18}
                                                    height={30}
                                                    onClick={() => handleEditClick(menu?.Menu_name, menu?.ID)}
                                                    clipPathId="clip0_5217_5102"
                                                />
                                                <DeleteIconSvg
                                                    onClick={() => handleDeleteMenuClick(menu?.ID)}
                                                />
                                            </div>
                                        </div>

                                        {Items[menu?.ID]?.length > 0 ? (
                                            <ul className="menu-starter-container-vendor">
                                                {Items[menu?.ID]?.map((item) => {

                                                    const cleanPrice = parseFloat(item?.Price).toString();

                                                    return (
                                                        <div key={item?.ID} className="menu-item">
                                                            <div className="vendor-menu-media-wrapper">
                                                                {item?.Avatar_key?.match(/\.(mp4|webm|ogg)$/i) ? (
                                                                    <div className="vendor-menu-video-container1">
                                                                        <video
                                                                            src={item?.Avatar_key}
                                                                            muted
                                                                            playsInline
                                                                            // eslint-disable-next-line react/no-unknown-property
                                                                            webkit-playsinline='true'
                                                                            autoPlay={selectedFood?.autoplay}
                                                                            preload="metadata"
                                                                            className="vendor-menu-food-video"
                                                                            ref={(el) => videoRefs.current[item?.ID] = el}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                const video = videoRefs.current[item?.ID];
                                                                                if (video && !video.paused) {
                                                                                    video.pause();
                                                                                    setPlayingIndex(null);
                                                                                }
                                                                            }}
                                                                            onEnded={() => setPlayingIndex(null)}
                                                                        />
                                                                        {playingIndex !== item?.ID && (
                                                                            <button onClick={(e) => handlePlay(e, item?.ID)} className='play-btn'>
                                                                                <IoPlayOutline color='white' fontSize={34} />
                                                                            </button>
                                                                        )}

                                                                    </div>
                                                                ) : (
                                                                    <img
                                                                        className='vendor-menu-Food-image'
                                                                        src={item?.Avatar_key || image1}
                                                                        alt='Food img'
                                                                        onError={(e) => {
                                                                            e.target.src = image1;
                                                                        }}
                                                                    />
                                                                )}
                                                            </div>
                                                            <div className="menu-description-container-vendor">
                                                                <div className="vendor-menu-name-description">
                                                                    <div className="svg-veg-non-veg-and-name-container">
                                                                        {item?.Vegetarian === false && (
                                                                            <img src={redDot} alt="red dot" />
                                                                        )}

                                                                        {item?.Vegetarian === true && (
                                                                            <img src={greenDot} alt="green dot" />
                                                                        )}
                                                                        <h3 className="menu-item-head-text">
                                                                            {item?.Item_name}
                                                                        </h3>
                                                                    </div>

                                                                    <p className="menu-description">
                                                                        <p className='menu-description' dangerouslySetInnerHTML={{
                                                                            __html: item.Description.length > 100
                                                                                ? item?.Description.slice(0, 100) + '...'
                                                                                : item?.Description
                                                                        }} />
                                                                        <b
                                                                            className="more-btm-menuitems"
                                                                            onClick={() => fetchFoodDetails(item?.ID, playingIndex === item?.ID)}
                                                                        >
                                                                            More...
                                                                        </b>
                                                                    </p>
                                                                </div>

                                                                <div className="menu-item-bottom-container">
                                                                    <h6 className="menu-item-price-text">
                                                                        ${cleanPrice}
                                                                    </h6>
                                                                    <div className="menu-edit-and-toggle">
                                                                        <button
                                                                            className="menu-edit-button"
                                                                            onClick={() => openEditPopup(item?.ID)}
                                                                        >
                                                                            <div className="menu-button-content">
                                                                                <EditPencilIconSvg
                                                                                    width={16}
                                                                                    height={16}
                                                                                    clipPathId="clip0_88_1492"
                                                                                />
                                                                            </div>
                                                                        </button>

                                                                        <button
                                                                            className="menu-edit-button"
                                                                            onClick={() => openDeletePopUp(item?.ID)}
                                                                        >
                                                                            <div className="menu-button-content">
                                                                                <DeleteIconSvg />
                                                                            </div>
                                                                        </button>

                                                                        <ToggleButton
                                                                            status={item?.Status}
                                                                            onToggle={(newStatus) =>
                                                                                handleToggleChange(item?.ID, newStatus)
                                                                            }
                                                                            itemId={item?.external_item_id}
                                                                            vendorID={vendorID}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </ul>
                                        ) : (
                                            <p className="no-items-message">No items in this menu</p>
                                        )}
                                    </div>
                                ))
                            )
                        ) : (
                            <div className="update-menu-items-main-container">
                                <div
                                    className="back-btn-menuItems"
                                    type="button"
                                    onClick={() => setIsAddingItem((prev) => !prev)}
                                >
                                    <div className="back-arrow-image-vendor">
                                        <img src={LeftArrow} alt="" />
                                    </div>
                                </div>
                                <div className="menu-new-div">
                                    <div className="menu-image-container">
                                        <div className="edit-image-or-video-svg-and-btn">
                                            <VendorImageMenuPlaceholderSvg
                                                onClick={() => fileInputRef.current.click()}
                                            />
                                            <h5 className="menu-add-item-update-photo-heading">
                                                Click to add Photo/Video
                                            </h5>
                                            <input
                                                type="file"
                                                ref={fileInputRef}
                                                style={{ display: 'none' }}
                                                accept="image/*,video/*"
                                                onChange={handleFileChange}
                                            />
                                        </div>

                                        <div className="image-or-video-preview-menuitems">
                                            {previewFile && fileType === 'image' && (
                                                <img
                                                    src={previewFile}
                                                    alt="Selected Preview"
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'contain',
                                                    }}
                                                />
                                            )}
                                            {previewFile && fileType === 'video' && (
                                                <video width="100%" height="100%" controls>
                                                    <source src={previewFile} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                </video>
                                            )}
                                        </div>

                                        {imageError && (
                                            <p
                                                style={{
                                                    fontSize: '16px',
                                                    color: 'red',
                                                    marginTop: '30px',
                                                    backgroundColor: 'white',
                                                    marginBottom: '10px',
                                                    padding: '10px',
                                                    borderRadius: '6px',
                                                }}
                                            >
                                                {imageError}
                                            </p>
                                        )}
                                    </div>
                                    <div className="menu-additem-rightside-content">
                                        <div className="menu-additem-rightside-content-1">
                                            <div className="menu-additem-food-name-container">
                                                <div className="add-menu-name-input">
                                                    <p className="menu-additem-food-name-text">
                                                        Food Name <span className="asterisk">*</span>
                                                    </p>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter Food Name"
                                                        className="menu-additem-food-name-inputbox"
                                                        value={itemName}
                                                        onChange={handleNameChange}
                                                        maxLength={30}
                                                        required
                                                    ></input>
                                                </div>
                                                {itemNameError && (
                                                    <p style={{ fontSize: '12px', color: 'red' }}>
                                                        {itemNameError}
                                                    </p>
                                                )}
                                            </div>
                                            <div className="menu-additem-food-name-container">
                                                <div className="add-menu-name-input">
                                                    <p className="menu-additem-food-name-text">
                                                        Menu Type <span className="asterisk">*</span>
                                                    </p>
                                                    <select
                                                        value={selectedMenuType}
                                                        onChange={handleMenuTypeChange}
                                                        className="menu-additem-menu-type-inputbox"
                                                    >
                                                        <option value="">select menu</option>
                                                        {menuTypes?.map((menu) => (
                                                            <option key={menu?.ID} value={menu?.ID}>
                                                                {menu?.Menu_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                {menuTypeError && (
                                                    <p style={{ fontSize: '12px', color: 'red' }}>
                                                        {menuTypeError}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="menu-additem-rightside-content-1">
                                            <div className="menu-additem-food-name-container">
                                                <div className="add-menu-name-input">
                                                    <p className="menu-additem-food-name-text">
                                                        Price <span className="asterisk">*</span>
                                                    </p>
                                                    <input
                                                        placeholder="$ 20"
                                                        value={itemPrice}
                                                        className="menu-additem-food-name-inputbox"
                                                        onChange={handlePriceChange}
                                                        // maxLength={3}
                                                        required
                                                    ></input>
                                                </div>
                                                {itemPriceError && (
                                                    <p style={{ fontSize: '12px', color: 'red' }}>
                                                        {itemPriceError}
                                                    </p>
                                                )}
                                            </div>
                                            <div className="menu-additem-food-name-container ">
                                                <div className="add-menu-name-input">
                                                    <p className="menu-additem-food-name-text">
                                                        Food Type <span className="asterisk">*</span>
                                                    </p>
                                                    <select
                                                        value={itemVegetarian}
                                                        onChange={handleVegetarianChange}
                                                        className="menu-additem-menu-type-inputbox"
                                                    >
                                                        <option value="">select</option>
                                                        <option value="false">Non-Veg</option>
                                                        <option value="true">Veg</option>
                                                    </select>
                                                </div>
                                                {itemVegetarianError && (
                                                    <p style={{ fontSize: '12px', color: 'red' }}>
                                                        {itemVegetarianError}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        {/* Item-level availability: only Daily and Party */}
                                        <div className="menu-additem-rightside-content-1" style={{ marginTop: 10 }}>
                                            <div className="menu-additem-food-name-container full-row" style={{ width: '100%' }}>
                                                <div className="add-menu-name-input" style={{ width: '100%' }}>
                                                    <p className="menu-additem-food-name-text">Available For</p>
                                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'center' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                            <span style={{ fontSize: 12, color: '#2c3142' }}>Daily</span>
                                                            <div
                                                                className={`menu-toggle-switch ${supportsDaily ? 'on' : 'off'}`}
                                                                onClick={() => setSupportsDaily(v => !v)}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                <div className="menu-toggle-switch-inner">
                                                                    <div className="menu-toggle-switch-circle" style={{ right: supportsDaily ? 3 : 'auto', left: supportsDaily ? 'auto' : 3 }}></div>
                                                                </div>
                                                                <span className={`menu-toggle-state-text ${supportsDaily ? 'on' : 'off'}`}>{supportsDaily ? 'on' : 'off'}</span>
                                                            </div>
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                            <span style={{ fontSize: 12, color: '#2c3142' }}>Party</span>
                                                            <div
                                                                className={`menu-toggle-switch ${supportsParty ? 'on' : 'off'}`}
                                                                onClick={() => setSupportsParty(v => !v)}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                <div className="menu-toggle-switch-inner">
                                                                    <div className="menu-toggle-switch-circle" style={{ right: supportsParty ? 3 : 'auto', left: supportsParty ? 'auto' : 3 }}></div>
                                                                </div>
                                                                <span className={`menu-toggle-state-text ${supportsParty ? 'on' : 'off'}`}>{supportsParty ? 'on' : 'off'}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {supportsParty && (
                                            <div className="menu-additem-rightside-content-1" style={{ marginTop: 12 }}>
                                                <div className="menu-additem-food-name-container full-row" style={{ width: '100%' }}>
                                                    <div className="add-menu-name-input" style={{ width: '100%' }}>
                                                        <p className="menu-additem-food-name-text">Party Tray Prices</p>
                                                        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                                                            <div style={{ minWidth: 180 }}>
                                                                <label style={{ display: 'block', fontSize: 12, color: '#2c3142', marginBottom: 4 }}>Small Tray</label>
                                                                <input
                                                                    type="text"
                                                                    inputMode="decimal"
                                                                    placeholder="$ e.g., 49.99"
                                                                    className="menu-additem-food-name-inputbox"
                                                                    value={smallTrayPrice}
                                                                    onChange={(e) => {
                                                                        let v = e.target.value.replace(/[^0-9.]/g, '');
                                                                        const parts = v.split('.');
                                                                        if (parts.length > 2) v = parts[0] + '.' + parts.slice(1).join('');
                                                                        setSmallTrayPrice(v);
                                                                    }}
                                                                />
                                                                {smallTrayPriceError && (
                                                                    <p style={{ marginTop: 4, fontSize: 11, color: 'red' }}>{smallTrayPriceError}</p>
                                                                )}
                                                            </div>
                                                            <div style={{ minWidth: 180 }}>
                                                                <label style={{ display: 'block', fontSize: 12, color: '#2c3142', marginBottom: 4 }}>Medium Tray</label>
                                                                <input
                                                                    type="text"
                                                                    inputMode="decimal"
                                                                    placeholder="$ e.g., 79.99"
                                                                    className="menu-additem-food-name-inputbox"
                                                                    value={mediumTrayPrice}
                                                                    onChange={(e) => {
                                                                        let v = e.target.value.replace(/[^0-9.]/g, '');
                                                                        const parts = v.split('.');
                                                                        if (parts.length > 2) v = parts[0] + '.' + parts.slice(1).join('');
                                                                        setMediumTrayPrice(v);
                                                                    }}
                                                                />
                                                                {mediumTrayPriceError && (
                                                                    <p style={{ marginTop: 4, fontSize: 11, color: 'red' }}>{mediumTrayPriceError}</p>
                                                                )}
                                                            </div>
                                                            <div style={{ minWidth: 180 }}>
                                                                <label style={{ display: 'block', fontSize: 12, color: '#2c3142', marginBottom: 4 }}>Large Tray</label>
                                                                <input
                                                                    type="text"
                                                                    inputMode="decimal"
                                                                    placeholder="$ e.g., 109.99"
                                                                    className="menu-additem-food-name-inputbox"
                                                                    value={largeTrayPrice}
                                                                    onChange={(e) => {
                                                                        let v = e.target.value.replace(/[^0-9.]/g, '');
                                                                        const parts = v.split('.');
                                                                        if (parts.length > 2) v = parts[0] + '.' + parts.slice(1).join('');
                                                                        setLargeTrayPrice(v);
                                                                    }}
                                                                />
                                                                {largeTrayPriceError && (
                                                                    <p style={{ marginTop: 4, fontSize: 11, color: 'red' }}>{largeTrayPriceError}</p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {partyTrayError ? (
                                                            <p style={{ marginTop: 6, fontSize: 11, color: 'red' }}>{partyTrayError}</p>
                                                        ) : (
                                                            <p style={{ marginTop: 6, fontSize: 11, color: '#6b7280' }}>Leave a tray price blank if you do not offer that size.</p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <div className="react-quill-description-ingrediants">
                                            <div className="add-menu-name-input">
                                                <p className="menu-additem-food-name-text">
                                                    Description <span className="asterisk">*</span>
                                                </p>
                                                <ReactQuill
                                                    theme="snow"
                                                    value={itemDescription}
                                                    onChange={handleDescriptionChange}
                                                    placeholder="Enter Description"
                                                    required
                                                />
                                            </div>
                                            {itemDescriptionError && (
                                                <p style={{ fontSize: '12px', color: 'red' }}>
                                                    {itemDescriptionError}
                                                </p>
                                            )}
                                        </div>
                                        <div className="react-quill-description-ingrediants">
                                            <div className="add-menu-name-input">
                                                <p className="menu-additem-food-name-ingridents">
                                                    Ingredients <span className="asterisk">*</span>
                                                </p>

                                                <ReactQuill
                                                    theme="snow"
                                                    value={itemIngredients}
                                                    onChange={handleItemIngredients}
                                                    placeholder="Enter Ingridents"
                                                    required
                                                />
                                            </div>
                                            {itemIngredientsError && (
                                                <p style={{ fontSize: '12px', color: 'red' }}>
                                                    {itemIngredientsError}
                                                </p>
                                            )}
                                        </div>
                                        <button className="menu-additem-btn" onClick={handleAddItem}>
                                            {' '}
                                            {isLoading ? 'Adding...' : 'Add Item'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {addMenuPopupOpen && (
                            <AddMenuType
                                open={addMenuPopupOpen}
                                onClose={closeAddMenuPopup}
                                onAddMenuType={handleAddMenuType}
                                isEditingMenu={isEditingMenu}
                                newMenuType={newMenuType}
                                setNewMenuType={setNewMenuType}
                                menuId={menuId}
                            />
                        )}

                        {selectedFood && (
                            <FoodMenuDetailsModal
                                open={openFoodDetail}
                                handleClose={handleClose}
                                food={selectedFood}
                                orderBtn={false}
                            />
                        )}

                        {showDeletePopup && (
                            <DeleteItem
                                onClose={closeDeletePopUp}
                                deleteID={deleteItemId}
                                fetchMenuTypes={fetchMenuTypes}
                                fetchMenuItems={fetchMenuItems}
                            />
                        )}

                        {deleteMenuPopupOpen && (
                            <DeleteMenu
                                open={deleteMenuPopupOpen}
                                onClose={closeDeleteMenuPopup}
                                newMenuType={newMenuType}
                                setNewMenuType={setNewMenuType}
                                menuId={menuIdToDelete}
                                deleteMenuType={deleteMenuType}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Menu;

